import { render, staticRenderFns } from "./driverChannelForm.vue?vue&type=template&id=9014f186&scoped=true"
import script from "./driverChannelForm.vue?vue&type=script&lang=js"
export * from "./driverChannelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9014f186",
  null
  
)

export default component.exports